import {TaskEvent} from "@core/model";
import {Loop} from "@mui/icons-material";
import {Stack, Typography} from "@mui/material";

const CalendarEvent = ({event}: {event: TaskEvent}) => {
  return (
    <Stack
      py={"2px"}
      gap={0.5}
      direction={"row"}
      alignItems={"center"}
      width={0}>
      {event.recurring && <Loop fontSize="inherit" />}
      <Typography
        variant="caption"
        textTransform={"capitalize"}
        lineHeight={1.2}>
        {event.title}
      </Typography>
    </Stack>
  );
};

export {CalendarEvent};
